import { Icon } from '@/components/icon';
import type { ProLayoutProps } from '@ant-design/pro-layout';
import { RoleName } from '@enmon/commons/lib/tools';
import { useUserInfo } from '@/hooks/useUser';

export const useRoutes = (): ProLayoutProps['route'] => {
  const { role } = useUserInfo() ?? {};
  return {
    path: '',
    children: [
      {
        path: `/`,
        key: '/',
        name: 'Dashboard',
        menu: {
          icon: <Icon $fontSize="16px" iconString="homeBlank" />,
        },
      },
      {
        path: `/portfolio/`,
        name: 'Your portfolio',
        menu: {
          icon: <Icon $fontSize="16px" iconString="suitcase" />,
        },
        children: [
          {
            path: `customers`,
            name: 'Customers',
          },
          {
            path: `locations`,
            name: 'Locations',
          },
          {
            path: `meters`,
            name: 'Meters',
          },
        ],
      },
      {
        path: `/toolbox/`,
        name: 'Toolbox',
        menu: {
          icon: <Icon $fontSize="16px" iconString="toolbox" />,
        },
        children: [
          {
            path: `decoder`,
            name: 'Decoder',
          },
          {
            path: `invoices`,
            name: 'Invoices Parser',
          },
          {
            path: `gateways`,
            name: 'Gateways',
          },
        ],
      },
      {
        path: `/reseller-data/`,
        name: 'Reseller Data ',
        menu: {
          icon: <Icon $fontSize="16px" iconString="database" />,
        },
        children: [
          {
            path: `model-library`,
            name: 'Model Library',
          },
          {
            path: `templates`,
            name: 'Templates',
          },
          {
            path: 'persons',
            name: 'Persons',
          },
          {
            path: `hardwares`,
            name: 'Hardware List',
          },
          {
            path: `hardware-packages`,
            name: 'Hardware Packages',
          },
        ],
      },
      ...(role?.name === RoleName.Magic
        ? [
            {
              path: `/resellers`,
              name: 'Resellers',
              menu: {
                icon: <Icon $fontSize="16px" iconString="chartUpCircleDollar" />,
              },
            },
          ]
        : []),
      ...(import.meta.env.MODE !== 'production'
        ? [
            {
              path: `/examples`,
              name: 'Example layouts',
              menu: {
                icon: <Icon iconString="tableLayout" />,
              },
              children: [
                {
                  path: `data-details`,
                  name: 'Data Details',
                },
              ],
            },
          ]
        : []),
    ],
  };
};
